import { IExtraLogs } from './extra-logs.interface';
import { LogTypesEnum } from '../enums';

export interface ICreateLogDto {
    trip: string;
    message: string;
    datetime?: string;
    source?: string;
    createdBy?: string;
    createdByUserId?: string;
    type?: LogTypesEnum;
    seenBy?: string[];
    extra?: IExtraLogs;
}
